// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"7385":"styles-d9be2450","8859":"styles-08299269"}[chunkId] + "." + {"7385":"b46c715c3ccc47bc1d31","8859":"c4a9d9a1a25064bd3247"}[chunkId] + ".css";
};